import { Partner } from "../Stores/PartnerStore";
import Assessment, { IAssessmentSnapshotIn } from "./Assessment";

export const MedicalAssessmentQuestionsSnapshot = [
  {
    key: "MedicalDomainTask1",
    timeToComplete: null,
    question:
      "Have you worked with your older adult to be sure they complete a comprehensive geriatric medical assessment with a geriatric physician or primary care physician?",
    answer: "",
    taskName: "Geriatric Medical Assessment",
  },
  {
    key: "MedicalDomainTask2",
    timeToComplete: null,
    question:
      "Have you learned how to monitor and respond to changes in your older adult’s health and functional status?",
    answer: "",
    taskName: "Monitoring Changes",
  },
  {
    key: "MedicalDomainTask3",
    timeToComplete: null,
    question:
      "Have you had a conversation with your older adult to see if they are comfortable with your help and with your being a part of their health care team?",
    answer: "",
    taskName: "Healthcare Team",
  },
  {
    key: "MedicalDomainTask4",
    timeToComplete: null,
    question:
      "Have you created a medication list with all your loved one’s medications and made plans to keep it up to date?",
    answer: "",
    taskName: "Medication Management",
  },
  {
    key: "MedicalDomainTask5",
    timeToComplete: null,
    question:
      "Have you developed a plan with the older adult to evaluate their driving skills on a regular basis?",
    answer: "",
    taskName: "Evaluate Driving Skills",
  },
  {
    key: "MedicalDomainTask6",
    timeToComplete: null,
    question:
      "Have you met with a geriatric care manager to create or update the older adult's plan of care?",
    answer: "",
    taskName: "Geriatric Care Manager",
  },
  {
    key: "MedicalDomainTask7",
    timeToComplete: null,
    question:
      "Have you assessed the quality and appropriateness of care in retirement and healthcare facilities (e.g., nursing homes, assisted-living facilities, dementia-care units, aging-in-place facilities) in the older adult's community?",
    answer: "",
    taskName: "Assess Facility Quality",
  },
  {
    key: "MedicalDomainTask8",
    timeToComplete: null,
    question:
      "Have you, after consultation with your parent's physician, worked with the older adult to develop a plan of physical exercise and activities appropriate to their health and interests?",
    answer: "",
    taskName: "Exercise and Activity Plan",
  },
  {
    key: "MedicalDomainTask9",
    timeToComplete: null,
    question:
      "Have you learned how to identify possible signs of cognitive impairment in the older adult and, if so, sought neurological consultation?",
    answer: "",
    taskName: "Cognitive Impairment",
  },
  {
    key: "MedicalDomainTask11",
    timeToComplete: null,
    question:
      "Have you learned about community services and technological sources of help for your older adult?",
    answer: "",
    taskName: "Community Services",
  },
];

export const DummyPartner = Partner.create({
  partnerId: "1",
  backgroundColor: "",
  navigationBarColor: "",
  fontColor: "",
});

export const MedicalAssessmentSnapshot: IAssessmentSnapshotIn = {
  id: "Medical",
  questions: MedicalAssessmentQuestionsSnapshot,
  infoSlideKeys: [
    "MedicalDomainTask1",
    "MedicalDomainTask2",
    "MedicalDomainTask3",
    "MedicalDomainTask4",
    "MedicalDomainTask5",
    "MedicalDomainTask6",
    "MedicalDomainTask7",
    "MedicalDomainTask8",
    "MedicalDomainTask9",
    // "MedicalDomainTask10",
    "MedicalDomainTask11",
  ],
};

export const DefaultMedicalAssessment = Assessment.create(
  MedicalAssessmentSnapshot
);
